import { Link } from 'react-router-dom';

interface LimitIndicatorProps {
  used: number;
  max: number;
  label: string;
  // null when there's no higher plan to upgrade to
  upgradeLink?: string | null;
}

export function LimitIndicator({ used, max, label, upgradeLink = '/pricing' }: LimitIndicatorProps) {
  const atLimit = used >= max;
  const nearLimit = used >= max * 0.8;

  return (
    <div className="w-full">
      <div className="text-xs mb-1">
        <span className={atLimit ? 'text-error font-medium' : nearLimit ? 'text-warning font-medium' : 'text-base-content/70'}>
          {used} of {max} {label.toLowerCase()} used
        </span>
      </div>
      <progress
        className={`progress w-full h-1.5 ${atLimit ? 'progress-error' : nearLimit ? 'progress-warning' : 'progress-primary'}`}
        value={used}
        max={max}
      />
      {atLimit && (
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-error">Limit reached</span>
          {upgradeLink && <Link to={upgradeLink} className="text-xs link link-primary">Upgrade</Link>}
        </div>
      )}
    </div>
  );
}
